import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { Button } from "@/@core/components/mui/Button"
import DialogCloseButton from "@/components/dialog/DialogCloseButton"
import { useTranslator } from "@/hooks/useTranslator"

export const AttendanceNotSavedDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean,
  onClose: () => void,
  onConfirm: () => void }) => {

  const { __ } = useTranslator()

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': { overflow: 'visible', maxWidth: '700', borderRadius: '32px' }
      }}
    >
      <DialogTitle className="text-center text-[24px] font-medium">
        {__('Attendance Not Saved')}
        <div className="text-center text-[15px] font-normal text-[#2f2b3db3]">
          {__('Warning: Unsaved attendance data. Do you want to leave this page?')}
        </div>
      </DialogTitle>

      <DialogContent>
        <DialogCloseButton onClick={onClose} disableRipple>
          <i className='tabler-x' />
        </DialogCloseButton>
        <div className="flex justify-center items-center">
          <img src="/images/pages/compute-icon.png" alt="not-saved" className="w-[300px] h-[300px] object-contain" />
        </div>
      </DialogContent>
      <DialogActions className="flex justify-center">
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          className="rounded-[6px] w-[104px]"
        >
          <span className="text-[15px] font-medium">
            {__('Continue')}
          </span>
        </Button>
        <Button
          onClick={onClose}
          variant="tonal"
          type="button"
          size="small"
          className="rounded-[6px] w-[104px]"
        >
          <span className="text-[15px] font-medium">
            {__('Cancel')}
          </span>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
